export const API_URL = false ? 'http://takwimu-api.test/api/v1' : 'https://backend-tk.ingauge.africa/api/v1';
export const APP_URL = process.env.NODE_ENV === 'development' ? 'https://takwimu.africa' : 'https://takwimu.africa';
export default { API_URL, APP_URL };
